module.exports = __webpack_public_path__ + "static/img/pic13.cea53bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic13.png
// module id = Dr9w
// module chunks = 0